import { useEffect, useState } from "react"
import GeneralTable from "../Tabellen/GeneralTable";
import { streckenverlaufHeader } from "../Tabellen/ConstTabKopf/StreckenverlaufKopf";
import StreckenverlaufAnzeige from "./StreckenverlaufAnzeige";
import { useNavigate } from "react-router-dom";
import InfraCreate from "./StreckenverlaufNeu";
import { MyNewButton } from "../StyleSheets/GeneralButtonStyles";

export default function Streckenverlauf({ strVerlInstance, bhfInstance, strInstance, absInstance, setTable, goBack }) {
    const [tableData, setTableData] = useState([]);
    const [bhfListe, setBhfListe] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        strVerlInstance.getVerlaufStreckenverlaufGet((error, data, response) => {
            if (error) {
                console.log(error);
            } else {
                console.log(data);
                console.log('>>load streckenverläufe useEffect');
                setTableData(data);
            }
        });
    }, [strVerlInstance]);

    useEffect(() => {
        bhfInstance.getListOfBahnhofsBahnhoflisteGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setBhfListe(data);
            }
        });
    }, [bhfInstance]);

    const reloadTableData = () => {
        strVerlInstance.getVerlaufStreckenverlaufGet((error, data, response) => {
            if (error) {
                console.log(error);
            } else {
                console.log('>>load streckenverläufe func');
                setTableData(data);
            }
        });
    }

    const detailCol = {
        id: "verlauf",
        Header: "",
        keyword: "info",
        Cell: ({ row }) => (
            <div>
                <StreckenverlaufAnzeige verlauf={row.original.strecke} />
            </div>
        )
    }


    const linkToDnD = event => {
        event.preventDefault();
        navigate(`../infra-basedOn`, { replace: true })
    }

    const close = event => {
        setTableData(null);
        setTable('');
        goBack();
    }

    return (
        <section >
            <InfraCreate bhfListe={bhfListe} absInstance={absInstance} reload={reloadTableData} strVerlInstance={strVerlInstance} />
            <MyNewButton onClick={linkToDnD} >&#43; neue Strecke auf Basis Bestehender</MyNewButton>

            {tableData.length > 1 && <div>
                <GeneralTable data={tableData} columns={streckenverlaufHeader} hiddenColumns={['id_strecke']} additionalColumns={[detailCol]} />
                <br></br>
                <button onClick={close}>Tabelle schließen</button>
            </div>}
        </section>
    )
}